import type { ReactNode } from "react"

import { useUi } from "@/core/i18n/locale-context"

interface AnswerBoxProps {
  children: ReactNode
  /** Usually a `<SourceLine />`. */
  source?: ReactNode
  label?: string
  /** Tighter padding on phones (tool pages that need the tool near the top). */
  compact?: boolean
}

export const AnswerBox = ({ children, source, label, compact = false }: AnswerBoxProps) => {
  const ui = useUi()
  return (
    <div
      className={`border-border border-l-primary bg-card grid gap-2 rounded-lg border border-l-4 px-5 py-4 ${compact ? "max-md:px-4 max-md:py-3" : ""}`}
    >
      <span className="text-primary text-xs font-semibold tracking-wider uppercase">
        {label ?? ui.shortAnswer}
      </span>
      <div className="text-base leading-relaxed">{children}</div>
      {source}
    </div>
  )
}
